import _ from 'lodash';
import template from './evidencijaNaloga.html';

class EvidencijaNalogaController {
    constructor(DS, $q) {
        this.datastore = () => DS;
        this.$q = () => $q;
        this.protetski_rad = [];
    }

    $onInit() {
        const DS = this.datastore();
        const $q = this.$q();
        this.item = this.item || undefined;
        if (this.item === undefined) {
            return;
        }

        this.ukupniIznos = 0;

        DS.find('Ordinacija', this.item.ordinacija).then(response => {
            this.ordinacija = response;
        });

        $q.all([DS.findAll('ProtetskiRad'), DS.findAll('StavkaCjenika')]).then(response => {
            const [protetskiRadovi, stavkeCjenika] = response;
            const StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
            this.stavke = StavkaNaloga.group(this.item.stavke);

            this.stavke.map(stavka => {
                const protetskiRad = _.find(protetskiRadovi, { id: stavka.protetski_rad });
                const stavkaCjenika = _.find(stavkeCjenika, {
                    cjenik: stavka.cjenik,
                    protetski_rad: stavka.protetski_rad
                });
                stavka.nazivProtetskogRada = protetskiRad.naziv;
                stavka.jedinicnaCijena = stavkaCjenika.iznos;
                stavka.kolicina = stavka.pozicije.length;
                stavka.iznos = stavka.jedinicnaCijena * stavka.kolicina;
                this.ukupniIznos = this.ukupniIznos + stavka.iznos;
            });
            // this.protetski_rad = response;
            // this.stavke = this.item.stavke;
        });
    }

    resolveNazivProtetskogRada(stavka) {
        const item = _.find(this.protetski_rad, { id: stavka.protetski_rad });
        if (_.isUndefined(item)) {
            return '';
        }
        return item.naziv;
    }
}

EvidencijaNalogaController.$inject = ['DS', '$q'];

const EvidencijaNalogaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: EvidencijaNalogaController,
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};

export { EvidencijaNalogaComponent };
export { EvidencijaNalogaController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/evidencijaNaloga.component.js